import { useAtom } from 'jotai'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import ReviewModal from 'src/modules/Modals/components/ReviewModal'
import {
  getInvoicesInFlight,
  getShippedOrders
} from 'src/modules/MyAccount/components/PastOrders/selectors'
import { getInvoices } from 'src/redux-api-bridge'
import { ClipLoader } from 'react-spinners'
import { CuiModal } from 'front-lib'
import { rateMealsModalAtom } from 'src/atoms/modals/rateMealsModal.atom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useExclusiveModal } from 'src/hooks/useExclusiveModalAtom'

import './RateMealsModal.scss'

export function RateMealsModal() {
  useExclusiveModal(userOnboardingModalAtom)

  const dispatch = useDispatch()
  const invoices = useSelector(getShippedOrders)
  const invoicesInFlight = useSelector(getInvoicesInFlight)
  const [{ isOpen }, setRateMealsModal] = useAtom(rateMealsModalAtom)

  const order = useMemo(() => {
    const invoice = invoices?.find(inv => inv.delivered)
    return invoice?.order
  }, [invoices])

  useEffect(() => {
    if (invoices?.length === 0 && !invoicesInFlight) {
      dispatch(
        getInvoices({
          date: {
            from: moment()
              .subtract(2, 'months')
              .format('YYYY-MM-DD'),
            to: moment().format('YYYY-MM-DD')
          }
        })
      )
    }
  }, [invoices, invoicesInFlight, dispatch])

  return (
    (order && (
      <ReviewModal
        controlled
        isOpen={isOpen}
        onClose={() => setRateMealsModal({ isOpen: false })}
        selectedOrder={order}
        useShareModalSettings={false}
      />
    )) || (
      <CuiModal isOpen={isOpen} className="loader-container">
        <ClipLoader />
      </CuiModal>
    )
  )
}
